import React from "react"

import FieldProto_ConditionForm from "../../../../proto/render/condition/condition-form"
import ConditionTypeSelector from "../../../../proto/render/condition/condition-type-selector"
import FieldFormElementView from "../../../../render/form-elemnent-view"
import {getMomentConditionValueField, defaultMomentConditionValue} from "./condition-value"

// const debug = "FieldMoment_ConditionForm"
const debug = false

export default class FieldMoment_ConditionForm extends FieldProto_ConditionForm {
    render() {
        debug && console.log(debug, 'render', this.state)

        const valueField = getMomentConditionValueField(this.props.condition.type)

        if (!valueField) {
            console.warn("FieldMoment_ConditionForm: unknown condition type for value", this.props.condition.type)
        } else if (!this.props.condition.value) {
            const def = defaultMomentConditionValue(this.props.condition.type)
            if (def !== undefined) {
                this.props.condition.value = def
            }
        }

        return (
            <>
                <ConditionTypeSelector
                    field       = {this.props.field}
                    value       = {this.props.condition.type}
                    onChange    = {this.onChangeType}
                />

                {valueField &&
                    <FieldFormElementView
                        className   = "fl-no-shrink w-250 m-l-10"
                        field       = {valueField}
                        model       = {this.props.condition}
                        onChange    = {this.onChangeValue}
                    />
                }
            </>
        )
    }
}